import {AnimatePresence, motion} from 'motion/react';
import {forwardRef, InputHTMLAttributes, ReactNode} from 'react';
import {tv} from 'tailwind-variants';
import {cn, getMotionProps} from '../../libs';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  extra?: ReactNode;
}

const extraMotionProps = getMotionProps({
  initial: {x: 4, opacity: 0},
  animate: {x: 0, opacity: 1},
  exit: {x: 4, opacity: 0},
});

const input = tv({
  base: ['flex w-full rounded-md border transition-colors', 'disabled:cursor-not-allowed'],
  variants: {
    variant: {
      primary: [
        'bg-bg-secondary',
        'border-input-border',
        'placeholder:text-text-muted',
        'hover:border-input-border-hover',
        'focus:border-input-border-focus',
        'disabled:bg-bg-secondary-hover',
        'disabled:text-text-disabled',
      ],
    },
    disabled: {
      true: 'pointer-events-none',
    },
    size: {
      md: 'h-10 px-3 text-sm',
    },
  },
});

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  {extra, ...rest},
  ref,
) {
  return (
    <div className="relative">
      <input
        {...rest}
        ref={ref}
        className={cn(
          input({variant: 'primary', disabled: rest.disabled, size: 'md'}),
          extra && 'pr-8',
          rest.className,
        )}
      />
      <AnimatePresence>
        {extra && (
          <motion.div
            {...extraMotionProps}
            className="absolute top-1/2 right-2 -translate-y-1/2 text-text-disabled"
          >
            {extra}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
});
